import React, { useState } from 'react';
import InfoModal from './InfoModal';

const InfoTooltip = ({ children, ariaLabel = 'Подробнее', title = 'Важно знать', trigger = 'icon', position = 'right' }) => {
    const [open, setOpen] = useState(false);

    const toggle = () => setOpen((v) => !v);
    const close = () => setOpen(false);

    return (
        <span className={`info-tooltip info-tooltip-${position}`}>
            {trigger === 'text' ? (
                <div className="sidebar-widget sidebar-widget-clickable-minimal" onClick={toggle}>
                    <div className="widget-header">
                        <h4 className="widget-title">
                            <span className="widget-icon">📘</span> Почему договор найма? 
                        </h4>
                    </div>
                    <p className="widget-content">
                        В быту мы говорим «аренда», но юридически для жилья между физлицами это договор найма.
                    </p>
                    <div className="widget-footer">
                        <span className="widget-hint">Нажмите для подробностей</span>
                    </div>
                </div>
            ) : (
                <button type="button" className="info-tooltip-trigger" aria-label={ariaLabel} onClick={toggle}>?</button>
            )}

            <InfoModal isOpen={open} onClose={close} title={title}>
                {children}
            </InfoModal>
        </span>
    );
};

export default InfoTooltip;


